// Tipovi za native WS bridge transport — kad MAUI shell poseduje WebSocket, a Angular
// šalje/prima frame-ove preko crossAppMessaging mosta (akcije ws.* / poruke ws.message, ws.state).

export interface WsBridgeCapabilities {
  ws: boolean;
  wsProtocolVersion: number;
  nativeAppVersion: string;
  state: WsBridgeConnectionState;
  url: string | null;
}

export type WsBridgeConnectionState = 'disconnected' | 'connecting' | 'connected';

export interface WsBridgeState {
  state: WsBridgeConnectionState;
  url: string | null;
  retryCount: number;
  nextRetryInSec: number;
  reason?: string;
}

// localStorage keš odluke o transportu: stari APK (bez bridge-a) ne sme da plaća
// probe timeout na svakom boot-u. Per-boot probe i dalje presuđuje kad je keš true/odsutan.
export const WS_BRIDGE_CACHE_KEY = 'ws.nativeTransport';

export interface WsBridgeTransportCache {
  supported: boolean;
  nativeAppVersion?: string;
  at: string;
}
